export default function (Alpine) {
    Alpine.directive('slide', slide);
    // If we're using a "minimum width", we'll need to disable
    // x-show's default behavior of setting display: 'none'.
    slide.inline = function (el, _a) {
        var modifiers = _a.modifiers;
        if (!modifiers.includes('min'))
            return;
        el._x_doShow = function () { };
        el._x_doHide = function () { };
    };
    function slide(el, _a) {
        var modifiers = _a.modifiers;
        var duration = modifierValue(modifiers, 'duration', 250) / 1000;
        var floor = modifierValue(modifiers, 'min', 0);
        var fullyHide = !modifiers.includes('min');
        if (!el._x_isShown)
            el.style.width = "".concat(floor, "px");
        // We use the hidden attribute for the benefit of Tailwind
        // users as the .space utility will ignore [hidden] elements.
        // We also use display:none as the hidden attribute has very
        // low CSS specificity and could be accidentally overriden
        // by a user.
        if (!el._x_isShown && fullyHide)
            el.hidden = true;
        if (!el._x_isShown)
            el.style.overflow = 'hidden';
        // Override the setStyles function with one that won't
        // revert updates to the width style.
        var setFunction = function (el, styles) {
            var revertFunction = Alpine.setStyles(el, styles);
            return styles.width ? function () { } : revertFunction;
        };
        var transitionStyles = {
            transitionProperty: 'width',
            transitionDuration: "".concat(duration, "s"),
            transitionTimingFunction: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        };
        el._x_transition = {
            in: function (before, after) {
                if (before === void 0) { before = function () { }; }
                if (after === void 0) { after = function () { }; }
                if (fullyHide)
                    el.hidden = false;
                if (fullyHide)
                    el.style.display = null;
                var current = el.getBoundingClientRect().width;
                el.style.width = 'auto';
                var full = el.getBoundingClientRect().width;
                if (current === full) {
                    current = floor;
                }
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: { width: current + 'px' },
                    end: { width: full + 'px' },
                }, function () { return el._x_isShown = true; }, function () {
                    if (el.style.width == "".concat(full, "px")) {
                        el.style.overflow = null;
                    }
                });
            },
            out: function (before, after) {
                if (before === void 0) { before = function () { }; }
                if (after === void 0) { after = function () { }; }
                var full = el.getBoundingClientRect().width;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: { width: full + 'px' },
                    end: { width: floor + 'px' },
                }, function () { return el.style.overflow = 'hidden'; }, function () {
                    el._x_isShown = false;
                    // check if element is fully closed
                    if (el.style.width == "".concat(floor, "px") && fullyHide) {
                        el.style.display = 'none';
                        el.hidden = true;
                    }
                });
            },
        };
    }
}
function modifierValue(modifiers, key, fallback) {
    // If the modifier isn't present, use the default.
    if (modifiers.indexOf(key) === -1)
        return fallback;
    // If it IS present, grab the value after it: x-show.transition.duration.500ms
    var rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue)
        return fallback;
    if (key === 'duration') {
        // Support x-slide.duration.500ms && duration.500
        var match = rawValue.match(/([0-9]+)ms/);
        if (match)
            return match[1];
    }
    if (key === 'min') {
        // Support x-slide.min.100px && min.100
        var match = rawValue.match(/([0-9]+)px/);
        if (match)
            return match[1];
    }
    return rawValue;
}
